import type { FaireProductEntity } from "../../entity_types/product";

export const p_3v2kvcu3md: FaireProductEntity = {
  token: "p_3v2kvcu3md",
  type: "product",
  name: "2pk 100% Beeswax Tapers",
  brandToken: "b_kh9g2sdjb7",
  brandName: "Gifts From The Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/69a9e3afa32cd773ef9685b0c9397eb6db009a9c1f5719cfec18ded952c81120.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/66603a640aba19a5796411f1ec30d8cc59c92f0818b250a20ae67ccc35f0dc69.png",
    "https://cdn.faire.com/fastly/b9bb994991387d9309f24f31d17dfdb343c9cec09d1237eea518e52cc688b4db.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "Our Beeswax Tapers are hand-poured with 100% beeswax, cotton wicks, and are unscented. Give any space that cozy, rustic feel with these simple, clean burning tapers. \n\nAvailable in 12in,10in, 8in, or 6in heights.\n",
  tags: [],
  msrpDollars: 15,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:05.906Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
